"use strict";
var _a;
exports.__esModule = true;
var tslib_1 = require("tslib");
var platform_1 = tslib_1.__importDefault(require("platform"));
var Utils = tslib_1.__importStar(require("../../../common/lib/util/utils"));
var defaults_1 = tslib_1.__importDefault(require("../../../common/lib/util/defaults"));
var errorinfo_1 = tslib_1.__importDefault(require("../../../common/lib/types/errorinfo"));
var HttpMethods_1 = tslib_1.__importDefault(require("../../../common/constants/HttpMethods"));
var xhrrequest_1 = tslib_1.__importDefault(require("../transport/xhrrequest"));
var XHRStates_1 = tslib_1.__importDefault(require("../../../common/constants/XHRStates"));
var logger_1 = tslib_1.__importDefault(require("../../../common/lib/util/logger"));
var jsonptransport_1 = require("../transport/jsonptransport");
function shouldFallback(errorInfo) {
    var statusCode = errorInfo.statusCode;
    /* 400 + no code = a generic xhr onerror. Browser doesn't give us enough
     * detail to know whether it's fallback-fixable, but it may be (eg if a
     * network issue), so try just in case */
    return ((statusCode === 408 && !errorInfo.code) ||
        (statusCode === 400 && !errorInfo.code) ||
        (statusCode >= 500 && statusCode <= 504));
}
function getHosts(client) {
    /* If we're a connected realtime client, try the endpoint we're connected
     * to first -- but still have fallbacks, being connected is not an absolute
     * guarantee that a datacenter has free capacity to service REST requests. */
    var connection = client.connection, connectionHost = connection && connection.connectionManager.host;
    if (connectionHost) {
        return [connectionHost].concat(defaults_1["default"].getFallbackHosts(client.options));
    }
    return defaults_1["default"].getHosts(client.options);
}
var Http = (_a = /** @class */ (function () {
        function class_1() {
            this.checksInProgress = null;
            this.checkConnectivity = undefined;
            this.supportsAuthHeaders = false;
            this.supportsLinkHeaders = false;
            this._getHosts = getHosts;
            if (platform_1["default"].xhrSupported) {
                this.supportsAuthHeaders = true;
                this.Request = function (method, rest, uri, headers, params, body, callback) {
                    var req = xhrrequest_1["default"].createRequest(uri, headers, params, body, XHRStates_1["default"].REQ_SEND, rest && rest.options.timeouts, method);
                    req.once('complete', callback);
                    req.exec();
                    return req;
                };
                this.checkConnectivity = function (callback) {
                    var upUrl = defaults_1["default"].internetUpUrl;
                    logger_1["default"].logAction(logger_1["default"].LOG_MICRO, '(XHRRequest)Http.checkConnectivity()', 'Sending; ' + upUrl);
                    this.doUri(HttpMethods_1["default"].Get, null, upUrl, null, null, null, function (err, responseText) {
                        var _a;
                        var result = !err && ((_a = responseText) === null || _a === void 0 ? void 0 : _a.replace(/\n/, '')) == 'yes';
                        logger_1["default"].logAction(logger_1["default"].LOG_MICRO, '(XHRRequest)Http.checkConnectivity()', 'Result: ' + result);
                        callback(null, result);
                    });
                };
            }
            else if (platform_1["default"].jsonpSupported) {
                this.Request = function (method, rest, uri, headers, params, body, callback) {
                    var req = jsonptransport_1.createRequest(uri, headers, params, body, XHRStates_1["default"].REQ_SEND, rest && rest.options.timeouts, method);
                    req.once('complete', callback);
                    Utils.nextTick(function () {
                        req.exec();
                    });
                    return req;
                };
                this.checkConnectivity = function (callback) {
                    var _this = this;
                    var upUrl = defaults_1["default"].jsonpInternetUpUrl;
                    if (this.checksInProgress) {
                        this.checksInProgress.push(callback);
                        return;
                    }
                    this.checksInProgress = [callback];
                    logger_1["default"].logAction(logger_1["default"].LOG_MICRO, '(JSONP)Http.checkConnectivity()', 'Sending; ' + upUrl);
                    var req = new jsonptransport_1.Request('isTheInternetUp', upUrl, null, null, null, XHRStates_1["default"].REQ_SEND, defaults_1["default"].TIMEOUTS);
                    req.once('complete', function (err, response) {
                        var result = !err && response;
                        logger_1["default"].logAction(logger_1["default"].LOG_MICRO, '(JSONP)Http.checkConnectivity()', 'Result: ' + result);
                        for (var i = 0; i < _this.checksInProgress.length; i++)
                            _this.checksInProgress[i](null, result);
                        _this.checksInProgress = null;
                    });
                    Utils.nextTick(function () {
                        req.exec();
                    });
                };
            }
        }
        /* Unlike for doUri, the 'rest' param here is mandatory, as it's used to generate the hosts */
        class_1.prototype["do"] = function (method, rest, path, headers, body, params, callback) {
            var _this = this;
            var uriFromHost = typeof path == 'function'
                ? path
                : function (host) {
                    return rest.baseUri(host) + path;
                };
            var currentFallback = rest._currentFallback;
            if (currentFallback) {
                if (currentFallback.validUntil > Utils.now()) {
                    /* Use stored fallback */
                    if (!this.Request) {
                        callback === null || callback === void 0 ? void 0 : callback(new errorinfo_1["default"]('Request invoked before assigned to', null, 500));
                        return;
                    }
                    this.Request(method, rest, uriFromHost(currentFallback.host), headers, params, body, function (err) {
                        var args = [];
                        for (var _i = 1; _i < arguments.length; _i++) {
                            args[_i - 1] = arguments[_i];
                        }
                        // This typecast is safe because ErrnoExceptions are only thrown in NodeJS
                        if (err && shouldFallback(err)) {
                            /* unstore the fallback and start from the top with the default sequence */
                            rest._currentFallback = null;
                            _this["do"](method, rest, path, headers, body, params, callback);
                            return;
                        }
                        callback === null || callback === void 0 ? void 0 : callback.apply(void 0, tslib_1.__spreadArray([err], args));
                    });
                    return;
                }
                else {
                    /* Fallback expired; remove it and fallthrough to normal sequence */
                    rest._currentFallback = null;
                }
            }
            var hosts = getHosts(rest);
            /* if there is only one host do it */
            if (hosts.length === 1) {
                this.doUri(method, rest, uriFromHost(hosts[0]), headers, body, params, callback);
                return;
            }
            /* hosts is an array with preferred host plus at least one fallback */
            var tryAHost = function (candidateHosts, persistOnSuccess) {
                var host = candidateHosts.shift();
                _this.doUri(method, rest, uriFromHost(host), headers, body, params, function (err) {
                    var args = [];
                    for (var _i = 1; _i < arguments.length; _i++) {
                        args[_i - 1] = arguments[_i];
                    }
                    // This typecast is safe because ErrnoExceptions are only thrown in NodeJS
                    if (err && shouldFallback(err) && candidateHosts.length) {
                        tryAHost(candidateHosts, true);
                        return;
                    }
                    if (persistOnSuccess) {
                        /* RSC15f */
                        rest._currentFallback = {
                            host: host,
                            validUntil: Utils.now() + rest.options.timeouts.fallbackRetryTimeout,
                        };
                    }
                    callback === null || callback === void 0 ? void 0 : callback.apply(void 0, tslib_1.__spreadArray([err], args));
                });
            };
            tryAHost(hosts);
        };
        class_1.prototype.doUri = function (method, rest, uri, headers, body, params, callback) {
            if (!this.Request) {
                callback(new errorinfo_1["default"]('Request invoked before assigned to', null, 500));
                return;
            }
            this.Request(method, rest, uri, headers, params, body, callback);
        };
        return class_1;
    }()),
    _a.methods = [HttpMethods_1["default"].Get, HttpMethods_1["default"].Delete, HttpMethods_1["default"].Post, HttpMethods_1["default"].Put, HttpMethods_1["default"].Patch],
    _a.methodsWithoutBody = [HttpMethods_1["default"].Get, HttpMethods_1["default"].Delete],
    _a.methodsWithBody = [HttpMethods_1["default"].Post, HttpMethods_1["default"].Put, HttpMethods_1["default"].Patch],
    _a);
exports["default"] = Http;
